module.exports = {
  DEVICE: {
    ONLINE: "Device online",
    OFFLINE: "Device offline",
    RESTART: "Device restarted",
    UPGRADE: "Player upgraded",
  },
  DEPLOY: {
    DEPLOY: "Strategy deployed",
  },
  INAPP: {
    CRASH: ["Application crashed", "Application warning"],
  },
};
